import { render, staticRenderFns } from "./PatientHeaderCard.vue?vue&type=template&id=1ce37760&scoped=true&"
import script from "./PatientHeaderCard.vue?vue&type=script&lang=js&"
export * from "./PatientHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientHeaderCard.vue?vue&type=style&index=0&id=1ce37760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce37760",
  null
  
)

export default component.exports